import { defineStore, acceptHMRUpdate } from "pinia";
import { brogglBack } from "../axios.js";

export const useAuthStore = defineStore("auth", {
  state: () => ({
    error: null,
    resetPasswordError: null,
    params: {
      email: "",
      password: "",
    },
    paramsReset: {
      email: "",
      token: "",
      password: "",
    },
    token: "",
    user: {},
    passwordConfirmation: "",
    information: "",
    isAuthenticated: false,
  }),
  setUser(user) {
    this.user = user;
  },
  setToken(token) {
    this.token = token;
  },
  setIsAuthenticated(isAuthenticated) {
    this.isAuthenticated = isAuthenticated;
  },
  getters: {
    getError: (state) => {
      return state.error;
    },
    getResetPasswordError: (state) => {
      return state.resetPasswordError;
    },
    getParams: (state) => {
      return state.params;
    },
    getParamsReset: (state) => {
      return state.paramsReset;
    },
    getToken: (state) => {
      return state.token;
    },
    getPasswordConfirmation: (state) => {
      return state.passwordConfirmation;
    },
    getInformation: (state) => {
      return state.information;
    },
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    setToken(token) {
      this.token = token;
    },
    setIsAuthenticated(isAuthenticated) {
      this.isAuthenticated = isAuthenticated;
    },
    async signIn() {
      try {
        const res = await brogglBack.post("/user/login", this.params);
        this.token = res.data.data.token;
        this.user = res.data.data.user;
        this.error = null;
        this.params = {
          email: "",
          password: "",
        };
        let expires = new Date(Date.now() + 120 * 60 * 60 * 1000);
        window.$cookies.set("jwt", this.token, { expires: expires });
        window.$cookies.set("user", this.user, { expires: expires });
        this.router.push({ path: "/home" });
      } catch (err) {
        console.log(err);
        this.error = err;
      }
    },
    checkIfAlreadyLogged() {
      if (
        window.$cookies.get("jwt") !== null &&
        window.$cookies.get("jwt") !== undefined
      ) {
        this.router.push({ path: "/home" });
      } else {
        console.log("The token has expired");
      }
    },
    async resetPassword() {
      try {
        const res = await brogglBack.post(
          "/user/password-reset",
          this.paramsReset,
        );
        if (res.status === 200) {
          this.information = res.message;
        } else {
          this.resetPasswordError = res.message;
        }
        this.paramsReset = {
          password: "",
          token: "",
          email: "",
        };
        this.router.push({ path: "/" });
      } catch (err) {
        console.log(err);
        this.resetPasswordError = err;
      }
    },
  },
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useAuthStore, import.meta.hot));
}
